import { render, staticRenderFns } from "./DialogProductDO.vue?vue&type=template&id=73a760d5"
import script from "./DialogProductDO.vue?vue&type=script&lang=js"
export * from "./DialogProductDO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports